// extracted by mini-css-extract-plugin
module.exports = {"votesInput":"AddErc721Asset_votesInput__3kanW","tokenIdInput":"AddErc721Asset_tokenIdInput__2GF5t"};